<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .education-item {
    display: flex;
    flex-direction: column;
    padding: 0 utils.in_rem(8px);
    width: 100%;
    max-width: 100%;

    .school {
      @include mixins.h4();
      @include colors.color(textBlack);
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    .degree {
      @include mixins.body2();
      @include colors.color(textLighterBlack);
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    .duration {
      @include mixins.body2();
      @include colors.color(textGrey);
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    .field {
      @include mixins.body2();
      @include colors.color(textLighterBlack);
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
  }
</style>

<script>
  import { formatDate } from "./utils.js";

  export let education;

  $: startDate = formatDate(education.startedAt);
  $: endDate = formatDate(education.endedAt, "Present");

  $: duration = startDate && endDate ? `${startDate} - ${endDate}` : "";
</script>

<div class="education-item">
  {#if education.school}
    <h4 class="school">{education.school}</h4>
  {/if}

  {#if education.degree}
    <div class="degree">{education.degree}</div>
  {/if}

  {#if education.field}
    <div class="field">{education.field}</div>
  {/if}

  {#if duration}
    <div class="duration">{duration}</div>
  {/if}
</div>
